
export default{
    //设置cache
    set(key,value){
        return new Promise((resolve,reject)=>{
            localStorage.setItem(key,JSON.stringify(value));
            var flag = localStorage.getItem(key);
            if(flag){
                resolve();
            }else{
                reject();
            }
        })
    },
    get(key){
        var flag = localStorage.getItem(key);
        if(flag){
            return JSON.parse(flag);
        }else{
            return false;
        }
    },
    remove(key){
        return new Promise((resolve,reject)=>{
            localStorage.removeItem(key);
            var flag = localStorage.getItem(key);
            if(!flag){
                resolve();
            }else{
                reject();
            }
        })
    },
    clear(){
        return new Promise((resolve,reject)=>{
            localStorage.setItem('clearflag','true');
            localStorage.clear();
            var flag = localStorage.getItem('clearflag');
            if(!flag){
                resolve();
            }else{
                reject();
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/public/cache.js